import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LogoutRedirectState {
  // ログアウトのリダイレクト先のパス
  logoutRedirectTo: string | null;
  // ログアウト前にいたページのパス
  logoutPreviousPage: string | null;
}

const initialState: LogoutRedirectState = {
  logoutRedirectTo: null,
  logoutPreviousPage: null,
};

// 例えば、次のように状態が使用される想定です。
//   - 強制ログアウトのリダイレクト時に、logoutRedirectTo と logoutPreviousPage を記録しておく
//   - ログインするとき、ログイン場所が logoutRedirectTo と一致するとき、ログイン後に logoutPreviousPage にリダイレクトする
const logoutRedirectSlice = createSlice({
  name: "logoutRedirect",
  initialState,
  reducers: {
    logoutRedirectOccurred(
      state,
      action: PayloadAction<{
        logoutRedirectTo: string;
        logoutPreviousPage: string;
      }>
    ) {
      state.logoutRedirectTo = action.payload.logoutRedirectTo;

      // すでに値が設定されている場合は上書きしないようにします。
      // そうしないと、複数のリクエストを送信するページでログアウトとリダイレクトを行う場合、
      // 次のように、元いたページのパスの情報が消えてしまいます。
      //   1. 最初のリクエストで logoutPreviousPage に現在のページのパスが設定されてリダイレクトされる。
      //   2. 次のリクエストで logoutRedirectPage にリダイレクト先のパスが設定される。
      if (state.logoutPreviousPage === null) {
        state.logoutPreviousPage = action.payload.logoutPreviousPage;
      }
    },
    logoutRedirectInfoUsed(state) {
      state.logoutRedirectTo = null;
      state.logoutPreviousPage = null;
    },
  },
});

export const { logoutRedirectOccurred, logoutRedirectInfoUsed } =
  logoutRedirectSlice.actions;

export default logoutRedirectSlice.reducer;
